import HomeCategoryCard from "@/components/category/HomeCategoryCard/HomeCategoryCard";
import Image from "next/legacy/image";
import { PropTypes } from "prop-types";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  desktopLarge: {
    breakpoint: { max: 3000, min: 1500 },
    items: 6,
    slidesToSlide: 1,
  },
  desktopSmall: {
    breakpoint: { max: 1500, min: 1218 },
    items: 5,
    slidesToSlide: 1,
  },
  laptop: {
    breakpoint: { max: 1218, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },

  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 2,
    slidesToSlide: 1,
  },
};

const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className="absolute right-0 top-[3.125rem] bg-white w-[3rem] h-[3rem] rounded-[50%] border-[1px] border-[#EBEEF2]"
    >
      <Image
        src="/assets/icons/next-label-red.png"
        alt="next-arrow"
        width={8}
        height={16}
      />
    </button>
  );
};

const CustomLeftArrow = () => {
  return <button></button>;
};

function CategoriesMultiCardCarousel({ categories }) {
  return (
    <div>
      <Carousel
        swipeable={true}
        draggable={false}
        showDots={false}
        responsive={responsive}
        ssr={true}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={3500}
        keyBoardControl={true}
        transitionDuration={900}
        arrows={true}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        itemClass="carousel-item-padding-40-px"
      >
        {categories.map((category) => (
          <div key={category.slug} className="pl-1">
            <HomeCategoryCard
              categoryName={category.name}
              categorySlug={category.slug}
              imageHolderClassName="justify-center items-center w-[8.75rem] h-[8.75rem]"
              imageClassName="w-full h-full"
              textHolderClassName="w-[8.75rem]"
              imageUrl={category.logo}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default CategoriesMultiCardCarousel;

CategoriesMultiCardCarousel.propTypes = {
  categories: PropTypes.array,
};
